import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { publisherService } from "../../services/publisher.service";
import { IPublisherManagementState } from "../states/publisher-management-state";
import { IPublisher } from "../../models/interfaces/publisher/publisher.model.interface";
import { Publisher } from "../../models/publisher/publisher.model";
import { IPublisherDetailsRequest } from "../../models/interfaces/publisher/publisher-details-request.model.interface";
import { StatusType } from "@/enums/StatusType";

export const state: IPublisherManagementState = {
  publisher: new Publisher()
};

export const getters: GetterTree<IPublisherManagementState, RootState> = {
  publisher(state) {
    return state.publisher;
  }
};

export const mutations: MutationTree<IPublisherManagementState> = {
  publisher(state, publisher: IPublisher) {
    state.publisher = publisher;
  }
};

export const actions: ActionTree<IPublisherManagementState, RootState> = {
  async createPublisher({ commit }, publisher: IPublisherDetailsRequest) {
    return new Promise((resolve) => {
      publisherService.create(publisher)
        .then((value) => {
          if (value.success && value.result !== null) {
            commit("publisher", value.result);
          }

          resolve(value);
        });
    });
  },
  async retrievePublisher({ state, commit }, publisherId: number) {
    return new Promise((resolve, reject) => {
      publisherService.getPublisher(publisherId)
        .then((value) => {
          if (value.success) {
            commit("publisher", value.result);
          }
          resolve(value.success);
        });
    });
  },
  async updateDetails({ state }, publisher: IPublisher) {
    return new Promise((resolve, reject) => {
      const request: IPublisherDetailsRequest = {
        name: publisher.name
      };
      publisherService.updateDetails(publisher.publisherId, request).then((value) => {
        resolve(value);
      });
    });
  },
  async pausePublisher({ commit, dispatch }, publisher: IPublisher) {
    return new Promise((resolve) => {
        publisher.state.statusType = StatusType.Paused;
        publisherService.updateState(publisher.publisherId, publisher.state).then((value) => {
          dispatch("publisherModule/retrievePublishers", null, { root: true }).then((value) => {
            resolve(true);
          });
        });
    });
  },
  async setPublisherLive({ commit, dispatch }, publisher: IPublisher) {
    return new Promise((resolve) => {
        publisher.state.statusType = StatusType.Live;
        publisherService.updateState(publisher.publisherId, publisher.state).then((value) => {
          dispatch("publisherModule/retrievePublishers", null, { root: true }).then((value) => {
            resolve(true);
          });
        });
    });
  },
};

export const publisherManagementModule: Module<IPublisherManagementState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
